<!--
 * @Author: 刘帅博 liushuaibo@yangxuan.net
 * @Date: 2023-09-20 16:58:57
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-25 12:00:18
 * @FilePath: \partner.chaoyongtuan.com\src\views\secondColonelManage\colonelActivitySquare\detail\components\ksTableCell\extensionTimeCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="extensionTimeCell font-h6-regular yx-color-text-primary">
		<span>{{ `${row[column['startTime']]}` | formatDate }}</span>
		<span class="ml-4 mr-4">至</span>
		<span>{{ `${row[column['endTime']]}` | formatDate }}</span>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
};
</script>